// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__36FeW","info":"Note_info__Ttloi","note":"Note_note__3pbQ7","actions":"Note_actions__VmaiW"};